/* ★ GAMBAR PRODUK — Control Panel tab Flow (enjin RESIPI, gambar berlainan setiap scene, 31 Okt 2026, PLAN_FLOW_RESIPI.md).
 *
 * Pilihan pelanggan: scene mana guna gambar produk (+ avatar) sebagai rujukan bila gambar scene dijana.
 *   'semua'   — setiap scene (lalai) · 'pertama' — scene 1 · 'akhir' — scene terakhir · 'tiada' — AI reka daripada prompt
 * Laluan nilai: App.jsx `rujukanProduk` (useState, dipulihkan malas dari storan ini) → prop KEDUA-DUA render
 *   WorkspaceView → payload Run Flow `settings.flowRujukanProduk` → jambatan extension menyalin `settings`
 *   bulat-bulat → skrip remote flow-automation-resipi.js (`_resipiBaca`).
 * Simpanan per-browser SENDIRI (corak utils/hasilScene.js), ditulis HANYA dalam pengendali pilihan.
 * ⚠️ KEMBAR nilai: skrip flow-resipi/20-resipi.js `RESIPI_RUJUKAN`.
 */

export const RUJUKAN_PRODUK = ['semua', 'pertama', 'akhir', 'tiada'];
const KUNCI = 'sesaat_rujukan_produk_v1';

/* SIMPAN GAMBAR — Images only: 'folder' (lalai) · 'kad' = folder + card. ⚠️ KEMBAR `_resipiBaca` 20-resipi.js. */
export const SIMPAN_GAMBAR = ['folder', 'kad'];
const KUNCI_SIMPAN = 'sesaat_simpan_gambar_v1';

/* BIL OUTPUT — Images only: berapa gambar setiap prompt (x1–x4 panel Flow). ⚠️ KEMBAR `_resipiBaca` 20-resipi.js. */
export const BIL_OUTPUT = ['1', '2', '3', '4'];
const KUNCI_OUTPUT = 'sesaat_bil_output_v1';

export function normBilOutput(v) {
    return BIL_OUTPUT.includes(String(v)) ? String(v) : '1';
}

export function bacaBilOutput() {
    try { return normBilOutput(localStorage.getItem(KUNCI_OUTPUT)); } catch { return '1'; }
}

export function simpanBilOutput(v) {
    const n = normBilOutput(v);
    try { localStorage.setItem(KUNCI_OUTPUT, n); } catch { /* storan ditutup — abai */ }
    return n;
}

export function normSimpanGambar(v) {
    return SIMPAN_GAMBAR.includes(v) ? v : 'folder';
}

export function bacaSimpanGambar() {
    try { return normSimpanGambar(localStorage.getItem(KUNCI_SIMPAN)); } catch { return 'folder'; }
}

export function simpanSimpanGambar(v) {
    const n = normSimpanGambar(v);
    try { localStorage.setItem(KUNCI_SIMPAN, n); } catch { /* storan ditutup — abai */ }
    return n;
}

export function normRujukanProduk(v) {
    return RUJUKAN_PRODUK.includes(v) ? v : 'semua';
}

export function bacaRujukanProduk() {
    try { return normRujukanProduk(localStorage.getItem(KUNCI)); } catch { return 'semua'; }
}

export function simpanRujukanProduk(v) {
    const n = normRujukanProduk(v);
    try { localStorage.setItem(KUNCI, n); } catch { /* storan ditutup — abai */ }
    return n;
}
